/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Describes in what state a `Course` is.
 */
export const CourseState = /* #__PURE__ */ parsers.exactly('visible', 'archived', 'deleted');
